module.exports = __webpack_public_path__ + "public/images/modals/netw-choose-company-desktop.58369e82b66649ede3a673cc51970dac.png";